import EditableTable from '@components/EditableTable';
import { IDevice } from '@pages/Assets/Inventory/types';
import { Input, Space } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IDeviceActionRequestPayload } from '../types';

interface INicknameChangeProps {
  handleDeviceActions: (item: IDeviceActionRequestPayload) => void;
  actionKey: number;
  devicesProps: IDevice[] | undefined;
  uploadedDevices: any;
}

function usePlasticChange({
  actionKey,
  devicesProps,
  uploadedDevices,
  handleDeviceActions,
}: INicknameChangeProps) {
  const { t: translate } = useTranslation(['device-actions-modal']);
  const [devicesToExchangeData, setDevicesToExchangeData] = useState<any[]>();

  useEffect(() => {
    setDevicesToExchangeData(
      devicesProps?.map(device => ({
        key: device.id,
        msisdn: device.msisdn,
        iccid: device.iccid,
        processData: undefined,
      })),
    );
  }, [devicesProps]);

  const contentSteps = useMemo(() => {
    const handleChange = (value: string) => {
      setDevicesToExchangeData([
        { ...devicesToExchangeData?.[0], processData: value },
      ]);
    };
    if (devicesProps && devicesProps?.length > 0) {
      return [
        {
          title: translate('steps.exchange.ICCID', { field: 'ICCID' }),
          content:
            devicesProps && devicesProps?.length > 1 ? (
              <EditableTable
                data={devicesToExchangeData ?? []}
                columns={[
                  {
                    title: 'ICCID',
                    key: 'iccid',
                    dataIndex: 'iccid',
                  },
                  {
                    title: translate('steps.exchange.ICCID', {
                      field: 'ICCID',
                    }),
                    key: 'processData',
                    dataIndex: 'processData',
                    editable: true,
                    isRequired: false,
                  },
                ]}
                allowDelete={false}
                onChange={setDevicesToExchangeData}
              />
            ) : (
              <div style={{ padding: 16 }}>
                <Space style={{ textAlign: 'right' }}>
                  <span>{translate('steps.exchange.current')}</span>
                  <span style={{ fontWeight: 'bold', fontSize: '0.8rem' }}>
                    {devicesToExchangeData?.[0]?.iccid}
                  </span>
                </Space>
                <Input
                  onChange={({ target: { value } }) => handleChange(value)}
                  allowClear
                />
              </div>
            ),
        },
      ];
    }
    return [];
  }, [devicesProps, translate, devicesToExchangeData]);

  const reinitState = () => {
    setDevicesToExchangeData(undefined);
  };

  const onSubmit = () => {
    const payload: IDeviceActionRequestPayload = {};
    payload.action = actionKey;
    payload.devices =
      devicesProps && devicesProps?.length > 0
        ? devicesProps?.map(({ msisdn, iccid }: IDevice) => {
            return {
              msisdn,
              iccid,
              processData:
                devicesToExchangeData?.find(
                  (item: any) => item.msisdn === msisdn,
                ).processData || [],
            };
          })
        : uploadedDevices.map(({ ICCID, ...device }: IDevice) => ({
            ...device,
            processData: ICCID,
          }));

    return handleDeviceActions(payload);
  };

  const plasticChangeData = {
    contentSteps,
    onSubmit,
    reinitState,
  };

  return { plasticChangeData };
}

export default usePlasticChange;
